import React from 'react';
import Icon from '../../../components/AppIcon';


const RecentPromptsSection = ({ recentPrompts, onSelectPrompt }) => {
  if (!recentPrompts || recentPrompts?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="History" size={20} className="text-primary" />
          <h3 className="text-base md:text-lg font-semibold">Recent Prompts</h3>
        </div>
        <span className="text-xs text-muted-foreground">{recentPrompts?.length} saved</span>
      </div>
      <div className="space-y-2 md:space-y-3">
        {recentPrompts?.map((prompt, index) => (
          <button
            key={index}
            onClick={() => onSelectPrompt(prompt?.text)}
            className="w-full text-left p-3 md:p-4 bg-muted hover:bg-muted/80 rounded-lg transition-colors group"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium line-clamp-2 mb-1 group-hover:text-primary transition-colors">
                  {prompt?.text}
                </p>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <Icon name="Clock" size={12} />
                  <span>{prompt?.timestamp}</span>
                  <span>•</span>
                  <span>{prompt?.projectType}</span>
                </div>
              </div>
              <Icon name="ChevronRight" size={16} className="text-muted-foreground flex-shrink-0 mt-1" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RecentPromptsSection;